import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Input.scss';
import EditableText from '../EditableText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Input = function Input(_ref) {
  var className = _ref.className,
    children = _ref.children,
    disabled = _ref.disabled,
    multiline = _ref.multiline,
    inverted = _ref.inverted,
    password = _ref.password,
    email = _ref.email,
    date = _ref.date,
    number = _ref.number,
    name = _ref.name,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    unfocusable = _ref.unfocusable,
    value = _ref.value;
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    stateValue = _useState2[0],
    setStateValue = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    stateFocus = _useState4[0],
    setStateFocus = _useState4[1];
  var onChangeSelf = function onChangeSelf(e) {
    if ((stateValue || stateValue === '') && onChange) {
      // controlled
      onChange(e.target.value);
    } else {
      // uncontrolled
      setStateValue(e.target.value);
    }
  };
  var onChangeMultiline = function onChangeMultiline(newValue) {
    if ((stateValue || stateValue === '') && onChange) {
      // controlled
      if (newValue === '') {
        newValue = null;
      }
      onChange(newValue);
    } else {
      // uncontrolled
      setStateValue(newValue);
    }
  };
  var onBlur = function onBlur() {
    setStateFocus(false);
  };
  var onFocus = function onFocus() {
    setStateFocus(true);
  };
  var renderInput = function renderInput() {
    var type = 'text';
    if (password) {
      type = 'password';
    } else if (email) {
      type = 'email';
    } else if (date) {
      type = 'date';
    } else if (number) {
      type = 'number';
    }
    return /*#__PURE__*/_jsx("input", {
      type: type,
      disabled: disabled,
      tabIndex: unfocusable ? -1 : 0,
      placeholder: stateFocus ? null : placeholder,
      value: value || stateValue || '',
      name: name,
      onChange: onChangeSelf,
      autoFocus: stateFocus,
      onBlur: onBlur,
      onFocus: onFocus
    });
  };
  var renderMultiline = function renderMultiline() {
    return /*#__PURE__*/_jsx(EditableText, {
      invisible: true,
      disabled: disabled,
      unfocusable: unfocusable,
      value: value || stateValue || '',
      name: name,
      onChange: onChangeMultiline,
      onFocus: onFocus,
      onBlur: onBlur
    });
  };
  var classes = classNames('ptr-input-text', {
    empty: !(stateValue || value),
    focus: stateFocus,
    input: !multiline,
    inverted: !!inverted,
    multiline: multiline,
    disabled: disabled
  }, className);
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [multiline ? renderMultiline() : renderInput(), children]
  });
};
Input.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  inverted: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  unfocusable: PropTypes.bool,
  value: PropTypes.string,
  password: PropTypes.bool,
  email: PropTypes.bool,
  date: PropTypes.bool,
  number: PropTypes.bool,
  multiline: PropTypes.bool
};
export default Input;